/* eslint-disable require-yield,no-console,no-undef */
import { call, put, takeLatest } from 'redux-saga/effects';
import { webInfoApi, requestClientIdApi } from '../../../api/fetch';
import { isEmpty, isNumber } from 'lodash';
import moment from 'moment-timezone';
import { cacheSet } from '../../../helpers/Cache';

function* progressE(action) {
    let { staticInclude, clientInfo, maxWin, paramsWindow } = action.payload;

    //Lấy thông tin website
    let webInfo = null;
    // webInfo = cacheGet('webInfo');
    if (paramsWindow !== undefined && paramsWindow.design !== undefined && parseInt(paramsWindow.design, 10) === 1) webInfo = null;
    if (webInfo === null) {
        webInfo = yield call(webInfoApi, staticInclude);
        cacheSet('webInfo', webInfo, 600);
    }
    yield put({ type: 'WEB_SETTING', payload: webInfo });
    //Kiểm tra xem đã có profile chưa?
    if (isEmpty(clientInfo) || !isNumber(clientInfo.client_id)) {
        //Chưa có profile
        const client_id = yield call(requestClientIdApi, {});
        yield put({
            type: 'CLIENT_INFO',
            payload: {
                client_id,
                name: null,
                phone: null,
                email: null,
                address: null
            }
        });
    }


    //Check Rule để xác định được screen sẽ hiển thị đầu tiên
    // console.log(webInfo.websites.vi);
    const isShowChat = checkRuleClientInfo(webInfo.websites.vi, clientInfo);
    if (!isShowChat) {
        yield put({ type: 'SCREEN', payload: 'requestInfo' });
    } else {
        yield put({ type: 'SCREEN', payload: 'showChat' });
    }

    //Kiểm tra xem gói Vip hay gói Free
    const { expired } = webInfo.db;

    if (moment().tz('Asia/Ho_Chi_Minh').isAfter(expired)) {
        //Gói free
        /**
         * 1. Kiểm tra xem có đang mở Boxchat không. Nếu mở => Kết nối Ws, nếu không mở => Không kết nối Ws
         */
        if (maxWin) {
            yield put({ type: 'START_WS', payload: true });
            yield put({ type: 'IS_WAIT', payload: false });
        } else {
            yield put({ type: 'IS_WAIT', payload: false });
        }

    } else {
        //Gói Vip
        /**
         * Đối với Gói Vip thì thực hiện kết nối Ws luôn.
         */
        yield put({ type: 'START_WS', payload: true });
        yield put({ type: 'IS_WAIT', payload: false });
    }

}

function checkRuleClientInfo(webSetting, clientInfo) {
    let next = true;
    if (isEmpty(webSetting.importInformationAfterChat, 10) && parseInt(webSetting.importInformationAfterChat.status, 10) === 0) {
        return next;
    }

    if (parseInt(webSetting.importInformationAfterChat.status, 10) === 0) {
        return next;
    }

    if (
        (parseInt(webSetting.importInformationAfterChat.importInformationAfterChatName, 10) === 1
            || parseInt(webSetting.importInformationAfterChat.importInformationAfterChatNameRequire, 10) === 1)
        && isEmpty(clientInfo.name)) {
        next = false;
    }
    if (
        (parseInt(webSetting.importInformationAfterChat.importInformationAfterChatEmail, 10) === 1
            || parseInt(webSetting.importInformationAfterChat.importInformationAfterChatEmailRequire, 10) === 1)
        && isEmpty(clientInfo.email)) {
        next = false;
    }
    if (
        (parseInt(webSetting.importInformationAfterChat.importInformationAfterChatPhone, 10) === 1
            || parseInt(webSetting.importInformationAfterChat.importInformationAfterChatPhoneRequire, 10) === 1)
        && isEmpty(clientInfo.phone)) {
        next = false;
    }
    if (
        (parseInt(webSetting.importInformationAfterChat.importInformationAfterChatAddress, 10) === 1
            || parseInt(webSetting.importInformationAfterChat.importInformationAfterChatAddressRequire, 10) === 1)
        && isEmpty(clientInfo.address)) {
        next = false;
    }

    return next;
}

function* SagaFirst() {
    yield takeLatest('SAGA_FIRST', progressE);
}


export default SagaFirst;



// WEBPACK FOOTER //
// ./src/redux/saga/actions/SagaFirst.js